<template>
    <div v-show="allowedType" class="formgrid grid">
        <div class="field col-12">
            <label for="branch">Afdeling</label>
            <Dropdown inputId="branch" v-model="branch" :options="branches" optionLabel="name" optionValue="id">
            </Dropdown>
        </div>
        <div v-show="loading" class="field col-12">
            <p>Indlæser <i class="pi pi-spin pi-spinner"></i></p>
        </div>
    </div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
export default {
    name: "BranchSelector",
    props: ['branchesNodeId', 'allowedType'],
    components: {
        Dropdown
    },
    data() {
        return {
            branches: [],
            branch: -1,
            error: null,
            loading: false,
        };
    },
    watch: {
        branch(newValue, oldValue) {
            this.$emit('changeBranch',this.branches.find(x=>x.id == newValue));
        },
    },
    created() {
        const vm = this;
        vm.loading = true;
        var object = {
            branchesNodeId: vm.branchesNodeId
        };

        fetch("/umbraco/api/branchApi/GetOnlyBranches?" + new URLSearchParams(object)).then((response) => response.json())
            .then((data) => {
                vm.branches = data.items;
                vm.branches.unshift({ id: -1, name: "Vælg en afdeling" });
                vm.loading = false;
            })
            .catch((error) => {
                console.log(error);
                vm.loading = false;

            });
    }
};
</script>
